<template>
  <el-container>
    <el-header>
      <Header />
    </el-header>
    <el-main>
      <div class="login">
        <div>
          <!-- <h1>{{ systemName }}</h1> -->
          <LoginForm
            :title="systemName"
          />
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container>
</template>
<script>
import Header from '@/components/organisms/Header.vue'
// import LoginForm from '@/components/organisms/LoginForm.vue'
import LoginForm from '@/components/organisms/UserConfirm.vue'
import Footer from '@/components/organisms/Footer.vue'

export default {
  components: {
    Header,
    LoginForm,
    Footer
  },
  data () {
    return {
      systemName: process.env.VUE_APP_SYSTEM_NAME
    }
  }
}
</script>
<style lang="scss" scoped>
.el-main {
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep .login {
    display: inline-block;
    border: solid 0.3rem #DFE3E1;
    border-radius: 1rem;
    padding: 2em 4em;
  }
}
h1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
